var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"page"},[_c('Headline',{attrs:{"title":_vm.headlineText,"icon":"mdi-chart-timeline-variant"}}),(_vm.$store.state.condAdmin.rvTableList != null)?_c('router-view',{on:{"setPageMode":_vm.setPageMode,"cancel":function($event){_vm.headlineText = _vm.$t('condAdmin.residualValuesList.headline')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }